interface CountryData {
	country_code: Uppercase<string>;
	nationality: string;
	flag: string;
	name: string;
	dial_code: string;
	phone_number_format?: string;
	group?: string;
}

export const COUNTRIES: CountryData[] = [
	{
		country_code: 'AF',
		nationality: 'Afghan',
		flag: '🇦🇫',
		name: 'Afghanistan',
		dial_code: '+93',
	},
	{
		country_code: 'AX',
		nationality: 'Ålandic',
		flag: '🇦🇽',
		name: 'Åland Islands',
		dial_code: '+358',
		phone_number_format: '## ### ## ##',
	},
	{
		country_code: 'AL',
		nationality: 'Albanian',
		flag: '🇦🇱',
		name: 'Albania',
		dial_code: '+355',
	},
	{
		country_code: 'DZ',
		nationality: 'Algerian',
		flag: '🇩🇿',
		name: 'Algeria',
		dial_code: '+213',
	},
	{
		country_code: 'AS',
		nationality: 'American Samoan',
		flag: '🇦🇸',
		name: 'American Samoa',
		dial_code: '+1684',
	},
	{
		country_code: 'AD',
		nationality: 'Andorran',
		flag: '🇦🇩',
		name: 'Andorra',
		dial_code: '+376',
	},
	{
		country_code: 'AO',
		nationality: 'Angolan',
		flag: '🇦🇴',
		name: 'Angola',
		dial_code: '+244',
	},
	{
		country_code: 'AI',
		nationality: 'Anguillian',
		flag: '🇦🇮',
		name: 'Anguilla',
		dial_code: '+1264',
	},
	{
		country_code: 'AQ',
		nationality: 'Antarctic',
		flag: '🇦🇶',
		name: 'Antarctica',
		dial_code: '+672',
	},
	{
		country_code: 'AG',
		nationality: 'Antiguan or Barbudan',
		flag: '🇦🇬',
		name: 'Antigua and Barbuda',
		dial_code: '+1268',
	},
	{
		country_code: 'AR',
		nationality: 'Argentinean',
		flag: '🇦🇷',
		name: 'Argentina',
		dial_code: '+54',
		phone_number_format: '(##) ########',
	},
	{
		country_code: 'AM',
		nationality: 'Armenian',
		flag: '🇦🇲',
		name: 'Armenia',
		dial_code: '+374',
		phone_number_format: '## ######',
	},
	{
		country_code: 'AW',
		nationality: 'Aruban',
		flag: '🇦🇼',
		name: 'Aruba',
		dial_code: '+297',
	},
	{
		country_code: 'AU',
		nationality: 'Australian',
		flag: '🇦🇺',
		name: 'Australia',
		dial_code: '+61',
		phone_number_format: '(##) #### ####',
	},
	{
		country_code: 'AT',
		nationality: 'Austrian',
		flag: '🇦🇹',
		name: 'Austria',
		dial_code: '+43',
	},
	{
		country_code: 'AZ',
		nationality: 'Azerbaijani',
		flag: '🇦🇿',
		name: 'Azerbaijan',
		dial_code: '+994',
		phone_number_format: '(##) ### ## ##',
	},
	{
		country_code: 'BS',
		nationality: 'Bahamian',
		flag: '🇧🇸',
		name: 'Bahamas',
		dial_code: '+1242',
	},
	{
		country_code: 'BH',
		nationality: 'Bahraini',
		flag: '🇧🇭',
		name: 'Bahrain',
		dial_code: '+973',
	},
	{
		country_code: 'BD',
		nationality: 'Bangladeshi',
		flag: '🇧🇩',
		name: 'Bangladesh',
		dial_code: '+880',
	},
	{
		country_code: 'BB',
		nationality: 'Barbadian',
		flag: '🇧🇧',
		name: 'Barbados',
		dial_code: '+1246',
	},
	{
		country_code: 'BY',
		nationality: 'Belarusian',
		flag: '🇧🇾',
		name: 'Belarus',
		dial_code: '+375',
		phone_number_format: '(##) ### ## ##',
	},
	{
		country_code: 'BE',
		nationality: 'Belgian',
		flag: '🇧🇪',
		name: 'Belgium',
		dial_code: '+32',
		phone_number_format: '### ## ## ##',
	},
	{
		country_code: 'BZ',
		nationality: 'Belizean',
		flag: '🇧🇿',
		name: 'Belize',
		dial_code: '+501',
	},
	{
		country_code: 'BJ',
		nationality: 'Beninese',
		flag: '🇧🇯',
		name: 'Benin',
		dial_code: '+229',
	},
	{
		country_code: 'BM',
		nationality: 'Bermudian',
		flag: '🇧🇲',
		name: 'Bermuda',
		dial_code: '+1441',
	},
	{
		country_code: 'BT',
		nationality: 'Bhutanese',
		flag: '🇧🇹',
		name: 'Bhutan',
		dial_code: '+975',
	},
	{
		country_code: 'BO',
		nationality: 'Bolivian',
		flag: '🇧🇴',
		name: 'Bolivia, Plurinational State of bolivia',
		dial_code: '+591',
	},
	{
		country_code: 'BA',
		nationality: 'Bosnian or Herzegovinian',
		flag: '🇧🇦',
		name: 'Bosnia and Herzegovina',
		dial_code: '+387',
	},
	{
		country_code: 'BW',
		nationality: 'Motswana',
		flag: '🇧🇼',
		name: 'Botswana',
		dial_code: '+267',
	},
	{
		country_code: 'BV',
		nationality: 'Bouvet Islander',
		flag: '🇧🇻',
		name: 'Bouvet Island',
		dial_code: '+47',
		phone_number_format: '### ## ###',
	},
	{
		country_code: 'BR',
		nationality: 'Brazilian',
		flag: '🇧🇷',
		name: 'Brazil',
		dial_code: '+55',
		phone_number_format: '(##) #########',
	},
	{
		country_code: 'IO',
		nationality: 'Indian',
		flag: '🇮🇴',
		name: 'British Indian Ocean Territory',
		dial_code: '+246',
	},
	{
		country_code: 'BN',
		nationality: 'Bruneian',
		flag: '🇧🇳',
		name: 'Brunei Darussalam',
		dial_code: '+673',
	},
	{
		country_code: 'BG',
		nationality: 'Bulgarian',
		flag: '🇧🇬',
		name: 'Bulgaria',
		dial_code: '+359',
	},
	{
		country_code: 'BF',
		nationality: 'Burkinabe',
		flag: '🇧🇫',
		name: 'Burkina Faso',
		dial_code: '+226',
	},
	{
		country_code: 'BI',
		nationality: 'Burundian',
		flag: '🇧🇮',
		name: 'Burundi',
		dial_code: '+257',
	},
	{
		country_code: 'KH',
		nationality: 'Cambodian',
		flag: '🇰🇭',
		name: 'Cambodia',
		dial_code: '+855',
	},
	{
		country_code: 'CM',
		nationality: 'Cameroonian',
		flag: '🇨🇲',
		name: 'Cameroon',
		dial_code: '+237',
	},
	{
		country_code: 'CA',
		nationality: 'Canadian',
		flag: '🇨🇦',
		name: 'Canada',
		dial_code: '+1',
		phone_number_format: '(###) ###-####',
	},
	{
		country_code: 'CV',
		nationality: 'Cape Verdian',
		flag: '🇨🇻',
		name: 'Cape Verde',
		dial_code: '+238',
	},
	{
		country_code: 'KY',
		nationality: 'Caymanian',
		flag: '🇰🇾',
		name: 'Cayman Islands',
		dial_code: '+345',
	},
	{
		country_code: 'CF',
		nationality: 'Central African',
		flag: '🇨🇫',
		name: 'Central African Republic',
		dial_code: '+236',
	},
	{
		country_code: 'TD',
		nationality: 'Chadian',
		flag: '🇹🇩',
		name: 'Chad',
		dial_code: '+235',
	},
	{
		country_code: 'CL',
		nationality: 'Chilean',
		flag: '🇨🇱',
		name: 'Chile',
		dial_code: '+56',
	},
	{
		country_code: 'CN',
		nationality: 'Chinese',
		flag: '🇨🇳',
		name: 'China',
		dial_code: '+86',
		phone_number_format: '##-#########',
	},
	{
		country_code: 'CX',
		nationality: 'Christmas Islander',
		flag: '🇨🇽',
		name: 'Christmas Island',
		dial_code: '+61',
		phone_number_format: '(##) #### ####',
	},
	{
		country_code: 'CC',
		nationality: 'Cocos Islander',
		flag: '🇨🇨',
		name: 'Cocos (Keeling) Islands',
		dial_code: '+61',
		phone_number_format: '(##) #### ####',
	},
	{
		country_code: 'CO',
		nationality: 'Colombian',
		flag: '🇨🇴',
		name: 'Colombia',
		dial_code: '+57',
		phone_number_format: '### ### ####',
	},
	{
		country_code: 'KM',
		nationality: 'Comoran',
		flag: '🇰🇲',
		name: 'Comoros',
		dial_code: '+269',
	},
	{
		country_code: 'CG',
		nationality: 'Congolese',
		flag: '🇨🇬',
		name: 'Congo',
		dial_code: '+242',
	},
	{
		country_code: 'CD',
		nationality: 'Congolese',
		flag: '🇨🇩',
		name: 'Congo, The Democratic Republic of the Congo',
		dial_code: '+243',
	},
	{
		country_code: 'CK',
		nationality: 'Cook Islander',
		flag: '🇨🇰',
		name: 'Cook Islands',
		dial_code: '+682',
	},
	{
		country_code: 'CR',
		nationality: 'Costa Rican',
		flag: '🇨🇷',
		name: 'Costa Rica',
		dial_code: '+506',
		phone_number_format: '####-####',
	},
	{
		country_code: 'CI',
		nationality: 'Ivorian',
		flag: '🇨🇮',
		name: "Cote d'Ivoire",
		dial_code: '+225',
	},
	{
		country_code: 'HR',
		nationality: 'Croatian',
		flag: '🇭🇷',
		name: 'Croatia',
		dial_code: '+385',
	},
	{
		country_code: 'CU',
		nationality: 'Cuban',
		flag: '🇨🇺',
		name: 'Cuba',
		dial_code: '+53',
	},
	{
		country_code: 'CY',
		nationality: 'Cypriot',
		flag: '🇨🇾',
		name: 'Cyprus',
		dial_code: '+357',
		phone_number_format: '## ######',
	},
	{
		country_code: 'CZ',
		nationality: 'Czech',
		flag: '🇨🇿',
		name: 'Czech Republic',
		dial_code: '+420',
		phone_number_format: '### ### ###',
	},
	{
		country_code: 'DK',
		nationality: 'Danish',
		flag: '🇩🇰',
		name: 'Denmark',
		dial_code: '+45',
		phone_number_format: '## ## ## ##',
		group: 'Frequently used',
	},
	{
		country_code: 'DJ',
		nationality: 'Djiboutian',
		flag: '🇩🇯',
		name: 'Djibouti',
		dial_code: '+253',
	},
	{
		country_code: 'DM',
		nationality: 'Dominican',
		flag: '🇩🇲',
		name: 'Dominica',
		dial_code: '+1767',
	},
	{
		country_code: 'DO',
		nationality: 'Dominican',
		flag: '🇩🇴',
		name: 'Dominican Republic',
		dial_code: '+1849',
	},
	{
		country_code: 'EC',
		nationality: 'Ecuadorean',
		flag: '🇪🇨',
		name: 'Ecuador',
		dial_code: '+593',
	},
	{
		country_code: 'EG',
		nationality: 'Egyptian',
		flag: '🇪🇬',
		name: 'Egypt',
		dial_code: '+20',
	},
	{
		country_code: 'SV',
		nationality: 'Salvadoran',
		flag: '🇸🇻',
		name: 'El Salvador',
		dial_code: '+503',
		phone_number_format: '####-####',
	},
	{
		country_code: 'GQ',
		nationality: 'Equatorial Guinean',
		flag: '🇬🇶',
		name: 'Equatorial Guinea',
		dial_code: '+240',
	},
	{
		country_code: 'ER',
		nationality: 'Eritrean',
		flag: '🇪🇷',
		name: 'Eritrea',
		dial_code: '+291',
	},
	{
		country_code: 'EE',
		nationality: 'Estonian',
		flag: '🇪🇪',
		name: 'Estonia',
		dial_code: '+372',
		phone_number_format: '#### ######',
	},
	{
		country_code: 'ET',
		nationality: 'Ethiopian',
		flag: '🇪🇹',
		name: 'Ethiopia',
		dial_code: '+251',
	},
	{
		country_code: 'FK',
		nationality: 'Falkland Islander',
		flag: '🇫🇰',
		name: 'Falkland Islands (Malvinas)',
		dial_code: '+500',
	},
	{
		country_code: 'FO',
		nationality: 'Faroese',
		flag: '🇫🇴',
		name: 'Faroe Islands',
		dial_code: '+298',
	},
	{
		country_code: 'FJ',
		nationality: 'Fijian',
		flag: '🇫🇯',
		name: 'Fiji',
		dial_code: '+679',
	},
	{
		country_code: 'FI',
		nationality: 'Finnish',
		flag: '🇫🇮',
		name: 'Finland',
		dial_code: '+358',
		phone_number_format: '## ### ## ##',
		group: 'Frequently used',
	},
	{
		country_code: 'FR',
		nationality: 'French',
		flag: '🇫🇷',
		name: 'France',
		dial_code: '+33',
		phone_number_format: '# ## ## ## ##',
		group: 'Frequently used',
	},
	{
		country_code: 'GF',
		nationality: 'French Guianese',
		flag: '🇬🇫',
		name: 'French Guiana',
		dial_code: '+594',
	},
	{
		country_code: 'PF',
		nationality: 'French Polynesian',
		flag: '🇵🇫',
		name: 'French Polynesia',
		dial_code: '+689',
	},
	{
		country_code: 'TF',
		nationality: 'French',
		flag: '🇹🇫',
		name: 'French Southern Territories',
		dial_code: '+262',
	},
	{
		country_code: 'GA',
		nationality: 'Gabonese',
		flag: '🇬🇦',
		name: 'Gabon',
		dial_code: '+241',
	},
	{
		country_code: 'GM',
		nationality: 'Gambian',
		flag: '🇬🇲',
		name: 'Gambia',
		dial_code: '+220',
	},
	{
		country_code: 'GE',
		nationality: 'Georgian',
		flag: '🇬🇪',
		name: 'Georgia',
		dial_code: '+995',
	},
	{
		country_code: 'DE',
		nationality: 'German',
		flag: '🇩🇪',
		name: 'Germany',
		dial_code: '+49',
		phone_number_format: '#### ########',
		group: 'Frequently used',
	},
	{
		country_code: 'GH',
		nationality: 'Ghanaian',
		flag: '🇬🇭',
		name: 'Ghana',
		dial_code: '+233',
	},
	{
		country_code: 'GI',
		nationality: 'Gibraltarian',
		flag: '🇬🇮',
		name: 'Gibraltar',
		dial_code: '+350',
	},
	{
		country_code: 'GR',
		nationality: 'Greek',
		flag: '🇬🇷',
		name: 'Greece',
		dial_code: '+30',
	},
	{
		country_code: 'GL',
		nationality: 'Greenlandic',
		flag: '🇬🇱',
		name: 'Greenland',
		dial_code: '+299',
	},
	{
		country_code: 'GD',
		nationality: 'Grenadian',
		flag: '🇬🇩',
		name: 'Grenada',
		dial_code: '+1473',
	},
	{
		country_code: 'GP',
		nationality: 'Guadeloupian',
		flag: '🇬🇵',
		name: 'Guadeloupe',
		dial_code: '+590',
	},
	{
		country_code: 'GU',
		nationality: 'Guamanian',
		flag: '🇬🇺',
		name: 'Guam',
		dial_code: '+1671',
	},
	{
		country_code: 'GT',
		nationality: 'Guatemalan',
		flag: '🇬🇹',
		name: 'Guatemala',
		dial_code: '+502',
		phone_number_format: '####-####',
	},
	{
		country_code: 'GG',
		nationality: 'Channel Islander',
		flag: '🇬🇬',
		name: 'Guernsey',
		dial_code: '+44',
		phone_number_format: '#### ######',
	},
	{
		country_code: 'GN',
		nationality: 'Guinean',
		flag: '🇬🇳',
		name: 'Guinea',
		dial_code: '+224',
	},
	{
		country_code: 'GW',
		nationality: 'Guinea-Bissauan',
		flag: '🇬🇼',
		name: 'Guinea-Bissau',
		dial_code: '+245',
	},
	{
		country_code: 'GY',
		nationality: 'Guyanese',
		flag: '🇬🇾',
		name: 'Guyana',
		dial_code: '+592',
	},
	{
		country_code: 'HT',
		nationality: 'Haitian',
		flag: '🇭🇹',
		name: 'Haiti',
		dial_code: '+509',
		phone_number_format: '####-####',
	},
	{
		country_code: 'HM',
		nationality: 'Heard and McDonald Islander',
		flag: '🇭🇲',
		name: 'Heard Island and Mcdonald Islands',
		dial_code: '+672',
	},
	{
		name: 'Holy See (Vatican City State)',
		flag: '🇻🇦',
		country_code: 'VA',
		nationality: 'Vatican',
		dial_code: '+379',
	},
	{
		country_code: 'HN',
		nationality: 'Honduran',
		flag: '🇭🇳',
		name: 'Honduras',
		dial_code: '+504',
	},
	{
		country_code: 'HK',
		nationality: 'Chinese',
		flag: '🇭🇰',
		name: 'Hong Kong',
		dial_code: '+852',
		phone_number_format: '#### ####',
	},
	{
		country_code: 'HU',
		nationality: 'Hungarian',
		flag: '🇭🇺',
		name: 'Hungary',
		dial_code: '+36',
	},
	{
		country_code: 'IS',
		nationality: 'Icelander',
		flag: '🇮🇸',
		name: 'Iceland',
		dial_code: '+354',
		phone_number_format: '### ####',
	},
	{
		country_code: 'IN',
		nationality: 'Indian',
		flag: '🇮🇳',
		name: 'India',
		dial_code: '+91',
		phone_number_format: '#####-#####',
	},
	{
		country_code: 'ID',
		nationality: 'Indonesian',
		flag: '🇮🇩',
		name: 'Indonesia',
		dial_code: '+62',
	},
	{
		country_code: 'IR',
		nationality: 'Iranian',
		flag: '🇮🇷',
		name: 'Iran, Islamic Republic of Persian Gulf',
		dial_code: '+98',
		phone_number_format: '### ### ####',
	},
	{
		country_code: 'IQ',
		nationality: 'Iraqi',
		flag: '🇮🇶',
		name: 'Iraq',
		dial_code: '+964',
	},
	{
		country_code: 'IE',
		nationality: 'Irish',
		flag: '🇮🇪',
		name: 'Ireland',
		dial_code: '+353',
		phone_number_format: '## #######',
	},
	{
		country_code: 'IM',
		nationality: 'Manx',
		flag: '🇮🇲',
		name: 'Isle of Man',
		dial_code: '+44',
		phone_number_format: '#### ######',
	},
	{
		country_code: 'IL',
		nationality: 'Israeli',
		flag: '🇮🇱',
		name: 'Israel',
		dial_code: '+972',
		phone_number_format: '### ### ####',
	},
	{
		country_code: 'IT',
		nationality: 'Italian',
		flag: '🇮🇹',
		name: 'Italy',
		dial_code: '+39',
		phone_number_format: '### #######',
		group: 'Frequently used',
	},
	{
		country_code: 'JM',
		nationality: 'Jamaican',
		flag: '🇯🇲',
		name: 'Jamaica',
		dial_code: '+1876',
	},
	{
		country_code: 'JP',
		nationality: 'Japanese',
		flag: '🇯🇵',
		name: 'Japan',
		dial_code: '+81',
		phone_number_format: '## #### ####',
	},
	{
		country_code: 'JE',
		nationality: 'Channel Islander',
		flag: '🇯🇪',
		name: 'Jersey',
		dial_code: '+44',
		phone_number_format: '#### ######',
	},
	{
		country_code: 'JO',
		nationality: 'Jordanian',
		flag: '🇯🇴',
		name: 'Jordan',
		dial_code: '+962',
	},
	{
		country_code: 'KZ',
		nationality: 'Kazakhstani',
		flag: '🇰🇿',
		name: 'Kazakhstan',
		dial_code: '+7',
		phone_number_format: '(###) ###-##-##',
	},
	{
		country_code: 'KE',
		nationality: 'Kenyan',
		flag: '🇰🇪',
		name: 'Kenya',
		dial_code: '+254',
	},
	{
		country_code: 'KI',
		nationality: 'I-Kiribati',
		flag: '🇰🇮',
		name: 'Kiribati',
		dial_code: '+686',
	},
	{
		country_code: 'KP',
		nationality: 'North Korean',
		flag: '🇰🇵',
		name: "Korea, Democratic People's Republic of Korea",
		dial_code: '+850',
	},
	{
		country_code: 'KR',
		nationality: 'South Korean',
		flag: '🇰🇷',
		name: 'Korea, Republic of South Korea',
		dial_code: '+82',
		phone_number_format: '### #### ####',
	},
	{
		name: 'Kosovo',
		flag: '🇽🇰',
		country_code: 'XK',
		nationality: 'Kosovar',
		dial_code: '+383',
	},
	{
		country_code: 'KW',
		nationality: 'Kuwaiti',
		flag: '🇰🇼',
		name: 'Kuwait',
		dial_code: '+965',
	},
	{
		country_code: 'KG',
		nationality: 'Kirghiz',
		flag: '🇰🇬',
		name: 'Kyrgyzstan',
		dial_code: '+996',
		phone_number_format: '### ### ###',
	},
	{
		country_code: 'LA',
		nationality: 'Laotian',
		flag: '🇱🇦',
		name: 'Laos',
		dial_code: '+856',
	},
	{
		country_code: 'LV',
		nationality: 'Latvian',
		flag: '🇱🇻',
		name: 'Latvia',
		dial_code: '+371',
		phone_number_format: '## ### ###',
	},
	{
		country_code: 'LB',
		nationality: 'Lebanese',
		flag: '🇱🇧',
		name: 'Lebanon',
		dial_code: '+961',
	},
	{
		country_code: 'LS',
		nationality: 'Mosotho',
		flag: '🇱🇸',
		name: 'Lesotho',
		dial_code: '+266',
	},
	{
		country_code: 'LR',
		nationality: 'Liberian',
		flag: '🇱🇷',
		name: 'Liberia',
		dial_code: '+231',
	},
	{
		country_code: 'LY',
		nationality: 'Libyan',
		flag: '🇱🇾',
		name: 'Libyan Arab Jamahiriya',
		dial_code: '+218',
	},
	{
		country_code: 'LI',
		nationality: 'Liechtensteiner',
		flag: '🇱🇮',
		name: 'Liechtenstein',
		dial_code: '+423',
	},
	{
		country_code: 'LT',
		nationality: 'Lithuanian',
		flag: '🇱🇹',
		name: 'Lithuania',
		dial_code: '+370',
	},
	{
		country_code: 'LU',
		nationality: 'Luxembourger',
		flag: '🇱🇺',
		name: 'Luxembourg',
		dial_code: '+352',
	},
	{
		country_code: 'MO',
		nationality: 'Chinese',
		flag: '🇲🇴',
		name: 'Macao',
		dial_code: '+853',
	},
	{
		country_code: 'MK',
		nationality: 'Macedonian',
		flag: '🇲🇰',
		name: 'Macedonia',
		dial_code: '+389',
	},
	{
		country_code: 'MG',
		nationality: 'Malagasy',
		flag: '🇲🇬',
		name: 'Madagascar',
		dial_code: '+261',
	},
	{
		country_code: 'MW',
		nationality: 'Malawian',
		flag: '🇲🇼',
		name: 'Malawi',
		dial_code: '+265',
	},
	{
		country_code: 'MY',
		nationality: 'Malaysian',
		flag: '🇲🇾',
		name: 'Malaysia',
		dial_code: '+60',
		phone_number_format: '##-####-####',
	},
	{
		country_code: 'MV',
		nationality: 'Maldivan',
		flag: '🇲🇻',
		name: 'Maldives',
		dial_code: '+960',
	},
	{
		country_code: 'ML',
		nationality: 'Malian',
		flag: '🇲🇱',
		name: 'Mali',
		dial_code: '+223',
	},
	{
		country_code: 'MT',
		nationality: 'Maltese',
		flag: '🇲🇹',
		name: 'Malta',
		dial_code: '+356',
	},
	{
		country_code: 'MH',
		nationality: 'Marshallese',
		flag: '🇲🇭',
		name: 'Marshall Islands',
		dial_code: '+692',
	},
	{
		country_code: 'MQ',
		nationality: 'French',
		flag: '🇲🇶',
		name: 'Martinique',
		dial_code: '+596',
	},
	{
		country_code: 'MR',
		nationality: 'Mauritanian',
		flag: '🇲🇷',
		name: 'Mauritania',
		dial_code: '+222',
	},
	{
		country_code: 'MU',
		nationality: 'Mauritian',
		flag: '🇲🇺',
		name: 'Mauritius',
		dial_code: '+230',
	},
	{
		country_code: 'YT',
		nationality: 'French',
		flag: '🇾🇹',
		name: 'Mayotte',
		dial_code: '+262',
	},
	{
		country_code: 'MX',
		nationality: 'Mexican',
		flag: '🇲🇽',
		name: 'Mexico',
		dial_code: '+52',
		phone_number_format: '### ### ####',
	},
	{
		country_code: 'FM',
		nationality: 'Micronesian',
		flag: '🇫🇲',
		name: 'Micronesia, Federated States of Micronesia',
		dial_code: '+691',
	},
	{
		country_code: 'MD',
		nationality: 'Moldovan',
		flag: '🇲🇩',
		name: 'Moldova',
		dial_code: '+373',
		phone_number_format: '(##) ##-##-##',
	},
	{
		country_code: 'MC',
		nationality: 'Monegasque',
		flag: '🇲🇨',
		name: 'Monaco',
		dial_code: '+377',
	},
	{
		country_code: 'MN',
		nationality: 'Mongolian',
		flag: '🇲🇳',
		name: 'Mongolia',
		dial_code: '+976',
	},
	{
		country_code: 'ME',
		nationality: 'Montenegrin',
		flag: '🇲🇪',
		name: 'Montenegro',
		dial_code: '+382',
	},
	{
		country_code: 'MS',
		nationality: 'Montserratian',
		flag: '🇲🇸',
		name: 'Montserrat',
		dial_code: '+1664',
	},
	{
		country_code: 'MA',
		nationality: 'Moroccan',
		flag: '🇲🇦',
		name: 'Morocco',
		dial_code: '+212',
	},
	{
		name: 'Mozambique',
		flag: '🇲🇿',
		country_code: 'MZ',
		nationality: 'Mozambican',
		dial_code: '+258',
	},
	{
		country_code: 'MM',
		nationality: 'Myanmar',
		flag: '🇲🇲',
		name: 'Myanmar',
		dial_code: '+95',
	},
	{
		country_code: 'NA',
		nationality: 'Namibian',
		flag: '🇳🇦',
		name: 'Namibia',
		dial_code: '+264',
	},
	{
		country_code: 'NR',
		nationality: 'Nauruan',
		flag: '🇳🇷',
		name: 'Nauru',
		dial_code: '+674',
	},
	{
		country_code: 'NP',
		nationality: 'Nepalese',
		flag: '🇳🇵',
		name: 'Nepal',
		dial_code: '+977',
	},
	{
		country_code: 'NL',
		nationality: 'Dutch',
		flag: '🇳🇱',
		name: 'Netherlands',
		dial_code: '+31',
		group: 'Frequently used',
	},
	{
		country_code: 'AN',
		nationality: 'Dutch',
		flag: '',
		name: 'Netherlands Antilles',
		dial_code: '+599',
	},
	{
		country_code: 'NC',
		nationality: 'New Caledonian',
		flag: '🇳🇨',
		name: 'New Caledonia',
		dial_code: '+687',
	},
	{
		country_code: 'NZ',
		nationality: 'New Zealander',
		flag: '🇳🇿',
		name: 'New Zealand',
		dial_code: '+64',
		phone_number_format: '###-###-####',
	},
	{
		country_code: 'NI',
		nationality: 'Nicaraguan',
		flag: '🇳🇮',
		name: 'Nicaragua',
		dial_code: '+505',
	},
	{
		country_code: 'NE',
		nationality: 'Nigerien',
		flag: '🇳🇪',
		name: 'Niger',
		dial_code: '+227',
	},
	{
		country_code: 'NG',
		nationality: 'Nigerian',
		flag: '🇳🇬',
		name: 'Nigeria',
		dial_code: '+234',
	},
	{
		country_code: 'NU',
		nationality: 'Niuean',
		flag: '🇳🇺',
		name: 'Niue',
		dial_code: '+683',
	},
	{
		country_code: 'NF',
		nationality: 'Norfolk Islander',
		flag: '🇳🇫',
		name: 'Norfolk Island',
		dial_code: '+672',
	},
	{
		country_code: 'MP',
		nationality: 'American',
		flag: '🇲🇵',
		name: 'Northern Mariana Islands',
		dial_code: '+1670',
	},
	{
		country_code: 'NO',
		nationality: 'Norwegian',
		flag: '🇳🇴',
		name: 'Norway',
		dial_code: '+47',
		phone_number_format: '### ## ###',
		group: 'Frequently used',
	},
	{
		country_code: 'OM',
		nationality: 'Omani',
		flag: '🇴🇲',
		name: 'Oman',
		dial_code: '+968',
	},
	{
		country_code: 'PK',
		nationality: 'Pakistani',
		flag: '🇵🇰',
		name: 'Pakistan',
		dial_code: '+92',
		phone_number_format: '###-#######',
	},
	{
		country_code: 'PW',
		nationality: 'Palauan',
		flag: '🇵🇼',
		name: 'Palau',
		dial_code: '+680',
	},
	{
		country_code: 'PS',
		nationality: 'Palestinian',
		flag: '🇵🇸',
		name: 'Palestinian Territory, Occupied',
		dial_code: '+970',
	},
	{
		country_code: 'PA',
		nationality: 'Panamanian',
		flag: '🇵🇦',
		name: 'Panama',
		dial_code: '+507',
	},
	{
		country_code: 'PG',
		nationality: 'Papua New Guinean',
		flag: '🇵🇬',
		name: 'Papua New Guinea',
		dial_code: '+675',
	},
	{
		country_code: 'PY',
		nationality: 'Paraguayan',
		flag: '🇵🇾',
		name: 'Paraguay',
		dial_code: '+595',
	},
	{
		country_code: 'PE',
		nationality: 'Peruvian',
		flag: '🇵🇪',
		name: 'Peru',
		dial_code: '+51',
	},
	{
		country_code: 'PH',
		nationality: 'Filipino',
		flag: '🇵🇭',
		name: 'Philippines',
		dial_code: '+63',
		phone_number_format: '#### #######',
	},
	{
		country_code: 'PN',
		nationality: 'Pitcairn Islander',
		flag: '🇵🇳',
		name: 'Pitcairn',
		dial_code: '+64',
		phone_number_format: '###-###-####',
	},
	{
		country_code: 'PL',
		nationality: 'Polish',
		flag: '🇵🇱',
		name: 'Poland',
		dial_code: '+48',
		phone_number_format: '###-###-###',
	},
	{
		country_code: 'PT',
		nationality: 'Portuguese',
		flag: '🇵🇹',
		name: 'Portugal',
		dial_code: '+351',
	},
	{
		country_code: 'PR',
		nationality: 'Puerto Rican',
		flag: '🇵🇷',
		name: 'Puerto Rico',
		dial_code: '+1939',
	},
	{
		country_code: 'QA',
		nationality: 'Qatari',
		flag: '🇶🇦',
		name: 'Qatar',
		dial_code: '+974',
	},
	{
		country_code: 'RO',
		nationality: 'Romanian',
		flag: '🇷🇴',
		name: 'Romania',
		dial_code: '+40',
	},
	{
		country_code: 'RU',
		nationality: 'Russian',
		flag: '🇷🇺',
		name: 'Russia',
		dial_code: '+7',
		phone_number_format: '(###) ###-##-##',
	},
	{
		country_code: 'RW',
		nationality: 'Rwandan',
		flag: '🇷🇼',
		name: 'Rwanda',
		dial_code: '+250',
	},
	{
		country_code: 'RE',
		nationality: 'French',
		flag: '🇷🇪',
		name: 'Reunion',
		dial_code: '+262',
	},
	{
		country_code: 'BL',
		nationality: 'Saint Barthélemy Islander',
		flag: '🇧🇱',
		name: 'Saint Barthelemy',
		dial_code: '+590',
	},
	{
		name: 'Saint Helena, Ascension and Tristan Da Cunha',
		flag: '🇸🇭',
		country_code: 'SH',
		nationality: 'Saint Helenian',
		dial_code: '+290',
	},
	{
		name: 'Saint Kitts and Nevis',
		flag: '🇰🇳',
		country_code: 'KN',
		nationality: 'Kittitian or Nevisian',
		dial_code: '+1869',
	},
	{
		name: 'Saint Lucia',
		flag: '🇱🇨',
		country_code: 'LC',
		nationality: 'Saint Lucian',
		dial_code: '+1758',
	},
	{
		country_code: 'MF',
		nationality: 'Saint Martin Islander',
		flag: '🇲🇫',
		name: 'Saint Martin',
		dial_code: '+590',
	},
	{
		name: 'Saint Pierre and Miquelon',
		flag: '🇵🇲',
		country_code: 'PM',
		nationality: 'French',
		dial_code: '+508',
	},
	{
		name: 'Saint Vincent and the Grenadines',
		flag: '🇻🇨',
		country_code: 'VC',
		nationality: 'Saint Vincentian',
		dial_code: '+1784',
	},
	{
		country_code: 'WS',
		nationality: 'Samoan',
		flag: '🇼🇸',
		name: 'Samoa',
		dial_code: '+685',
	},
	{
		country_code: 'SM',
		nationality: 'Sammarinese',
		flag: '🇸🇲',
		name: 'San Marino',
		dial_code: '+378',
	},
	{
		name: 'Sao Tome and Principe',
		flag: '🇸🇹',
		country_code: 'ST',
		nationality: 'Sao Tomean',
		dial_code: '+239',
	},
	{
		country_code: 'SA',
		nationality: 'Saudi Arabian',
		flag: '🇸🇦',
		name: 'Saudi Arabia',
		dial_code: '+966',
	},
	{
		country_code: 'SN',
		nationality: 'Senegalese',
		flag: '🇸🇳',
		name: 'Senegal',
		dial_code: '+221',
	},
	{
		country_code: 'RS',
		nationality: 'Serbian',
		flag: '🇷🇸',
		name: 'Serbia',
		dial_code: '+381',
	},
	{
		country_code: 'SC',
		nationality: 'Seychellois',
		flag: '🇸🇨',
		name: 'Seychelles',
		dial_code: '+248',
	},
	{
		country_code: 'SL',
		nationality: 'Sierra Leonean',
		flag: '🇸🇱',
		name: 'Sierra Leone',
		dial_code: '+232',
	},
	{
		country_code: 'SG',
		nationality: 'Singaporean',
		flag: '🇸🇬',
		name: 'Singapore',
		dial_code: '+65',
		phone_number_format: '####-####',
	},
	{
		country_code: 'SK',
		nationality: 'Slovak',
		flag: '🇸🇰',
		name: 'Slovakia',
		dial_code: '+421',
	},
	{
		country_code: 'SI',
		nationality: 'Slovene',
		flag: '🇸🇮',
		name: 'Slovenia',
		dial_code: '+386',
	},
	{
		country_code: 'SB',
		nationality: 'Solomon Islander',
		flag: '🇸🇧',
		name: 'Solomon Islands',
		dial_code: '+677',
	},
	{
		name: 'Somalia',
		flag: '🇸🇴',
		country_code: 'SO',
		nationality: 'Somali',
		dial_code: '+252',
	},
	{
		country_code: 'ZA',
		nationality: 'South African',
		flag: '🇿🇦',
		name: 'South Africa',
		dial_code: '+27',
	},
	{
		name: 'South Sudan',
		flag: '🇸🇸',
		country_code: 'SS',
		nationality: 'South Sudanese',
		dial_code: '+211',
	},
	{
		country_code: 'GS',
		nationality: 'South Georgia and South Sandwich Islander',
		flag: '🇬🇸',
		name: 'South Georgia and the South Sandwich Islands',
		dial_code: '+500',
	},
	{
		country_code: 'ES',
		nationality: 'Spanish',
		flag: '🇪🇸',
		name: 'Spain',
		dial_code: '+34',
		phone_number_format: '### ### ###',
		group: 'Frequently used',
	},
	{
		country_code: 'LK',
		nationality: 'Sri Lankan',
		flag: '🇱🇰',
		name: 'Sri Lanka',
		dial_code: '+94',
	},
	{
		country_code: 'SD',
		nationality: 'Sudanese',
		flag: '🇸🇩',
		name: 'Sudan',
		dial_code: '+249',
	},
	{
		country_code: 'SR',
		nationality: 'Surinamer',
		flag: '🇸🇷',
		name: 'Suriname',
		dial_code: '+597',
	},
	{
		country_code: 'SJ',
		nationality: 'Norwegian',
		flag: '🇸🇯',
		name: 'Svalbard and Jan Mayen',
		dial_code: '+47',
		phone_number_format: '### ## ###',
	},
	{
		country_code: 'SZ',
		nationality: 'Swazi',
		flag: '🇸🇿',
		name: 'Swaziland',
		dial_code: '+268',
	},
	{
		country_code: 'SE',
		nationality: 'Swedish',
		flag: '🇸🇪',
		name: 'Sweden',
		dial_code: '+46',
		phone_number_format: '(###) ###-###',
		group: 'Frequently used',
	},
	{
		country_code: 'CH',
		nationality: 'Swiss',
		flag: '🇨🇭',
		name: 'Switzerland',
		dial_code: '+41',
		phone_number_format: '## ### ## ##',
	},
	{
		country_code: 'SY',
		nationality: 'Syrian',
		flag: '🇸🇾',
		name: 'Syrian Arab Republic',
		dial_code: '+963',
	},
	{
		country_code: 'TW',
		nationality: 'Taiwanese',
		flag: '🇹🇼',
		name: 'Taiwan',
		dial_code: '+886',
	},
	{
		country_code: 'TJ',
		nationality: 'Tajik',
		flag: '🇹🇯',
		name: 'Tajikistan',
		dial_code: '+992',
	},
	{
		country_code: 'TZ',
		nationality: 'Tanzanian',
		flag: '🇹🇿',
		name: 'Tanzania, United Republic of Tanzania',
		dial_code: '+255',
	},
	{
		country_code: 'TH',
		nationality: 'Thai',
		flag: '🇹🇭',
		name: 'Thailand',
		dial_code: '+66',
	},
	{
		country_code: 'TL',
		nationality: 'East Timorese',
		flag: '🇹🇱',
		name: 'Timor-Leste',
		dial_code: '+670',
	},
	{
		country_code: 'TG',
		nationality: 'Togolese',
		flag: '🇹🇬',
		name: 'Togo',
		dial_code: '+228',
	},
	{
		country_code: 'TK',
		nationality: 'Tokelauan',
		flag: '🇹🇰',
		name: 'Tokelau',
		dial_code: '+690',
	},
	{
		country_code: 'TO',
		nationality: 'Tongan',
		flag: '🇹🇴',
		name: 'Tonga',
		dial_code: '+676',
	},
	{
		country_code: 'TT',
		nationality: 'Trinidadian or Tobagonian',
		flag: '🇹🇹',
		name: 'Trinidad and Tobago',
		dial_code: '+1868',
	},
	{
		country_code: 'TN',
		nationality: 'Tunisian',
		flag: '🇹🇳',
		name: 'Tunisia',
		dial_code: '+216',
	},
	{
		country_code: 'TR',
		nationality: 'Turkish',
		flag: '🇹🇷',
		name: 'Turkey',
		dial_code: '+90',
		phone_number_format: '### ### ## ##',
	},
	{
		country_code: 'TM',
		nationality: 'Turkmen',
		flag: '🇹🇲',
		name: 'Turkmenistan',
		dial_code: '+993',
	},
	{
		country_code: 'TC',
		nationality: 'Turks and Caicos Islander',
		flag: '🇹🇨',
		name: 'Turks and Caicos Islands',
		dial_code: '+1649',
	},
	{
		country_code: 'TV',
		nationality: 'Tuvaluan',
		flag: '🇹🇻',
		name: 'Tuvalu',
		dial_code: '+688',
	},
	{
		country_code: 'UG',
		nationality: 'Ugandan',
		flag: '🇺🇬',
		name: 'Uganda',
		dial_code: '+256',
	},
	{
		country_code: 'UA',
		nationality: 'Ukrainian',
		flag: '🇺🇦',
		name: 'Ukraine',
		dial_code: '+380',
		phone_number_format: '(##) ### ## ##',
	},
	{
		country_code: 'AE',
		nationality: 'Emirati',
		flag: '🇦🇪',
		name: 'United Arab Emirates',
		dial_code: '+971',
	},
	{
		country_code: 'GB',
		nationality: 'British',
		flag: '🇬🇧',
		name: 'United Kingdom',
		dial_code: '+44',
		phone_number_format: '#### ######',
		group: 'Frequently used',
	},
	{
		country_code: 'US',
		nationality: 'American',
		flag: '🇺🇸',
		name: 'United States',
		dial_code: '+1',
		phone_number_format: '(###) ###-####',
		group: 'Frequently used',
	},
	{
		country_code: 'UY',
		nationality: 'Uruguayan',
		flag: '🇺🇾',
		name: 'Uruguay',
		dial_code: '+598',
	},
	{
		country_code: 'UZ',
		nationality: 'Uzbekistani',
		flag: '🇺🇿',
		name: 'Uzbekistan',
		dial_code: '+998',
		phone_number_format: '## ### ## ##',
	},
	{
		country_code: 'VU',
		nationality: 'Ni-Vanuatu',
		flag: '🇻🇺',
		name: 'Vanuatu',
		dial_code: '+678',
	},
	{
		country_code: 'VE',
		nationality: 'Venezuelan',
		flag: '🇻🇪',
		name: 'Venezuela, Bolivarian Republic of Venezuela',
		dial_code: '+58',
	},
	{
		country_code: 'VN',
		nationality: 'Vietnamese',
		flag: '🇻🇳',
		name: 'Vietnam',
		dial_code: '+84',
	},
	{
		name: 'Virgin Islands, British',
		flag: '🇻🇬',
		country_code: 'VG',
		nationality: 'Virgin Islander',
		dial_code: '+1284',
	},
	{
		name: 'Virgin Islands, U.S.',
		flag: '🇻🇮',
		country_code: 'VI',
		nationality: 'Virgin Islander',
		dial_code: '+1340',
	},
	{
		country_code: 'WF',
		nationality: 'Wallis and Futuna Islander',
		flag: '🇼🇫',
		name: 'Wallis and Futuna',
		dial_code: '+681',
	},
	{
		country_code: 'YE',
		nationality: 'Yemeni',
		flag: '🇾🇪',
		name: 'Yemen',
		dial_code: '+967',
	},
	{
		country_code: 'ZM',
		nationality: 'Zambian',
		flag: '🇿🇲',
		name: 'Zambia',
		dial_code: '+260',
	},
	{
		country_code: 'ZW',
		nationality: 'Zimbabwean',
		flag: '🇿🇼',
		name: 'Zimbabwe',
		dial_code: '+263',
	},
];

export const COUNTRY_CODES = COUNTRIES.map((country) => country.country_code);

export const COUNTRY_PHONE_CODES_OPTIONS = COUNTRIES.map((country) => ({
	value: country.dial_code,
	label: country.dial_code,
}));

// Mantine v7 Combobox treats any data item carrying a `group` key as a group
// descriptor and reads `item.items` — a bare `group` (without nested `items`)
// throws "Cannot read properties of undefined (reading 'map')" and white-screens
// the app. These flat `{ value, label }` variants are kept for consumers that map
// or filter the list (validation, custom selects, table filters); plain `<Select>`
// consumers use the `*_GROUPED_OPTIONS` variants below to keep the v6 "Frequently
// used" group.
export const COUNTRIES_OPTIONS = COUNTRIES.map((country) => ({
	value: country.name,
	label: country.name,
}));

export const COUNTRIES_NAME_CODE_OPTIONS = COUNTRIES.map((country) => ({
	value: country.country_code,
	label: country.name,
}));

// Grouped variant for selects that surface a "Frequently used" shortcut group
// (e.g. tax-information country). v7 requires the nested `{ group, items }` shape
// — a bare `group` key on a flat item white-screens the app (see note above) — so
// the frequently-used countries are nested into a group and the remainder stay
// flat items rendered below it.
export const COUNTRIES_NAME_CODE_GROUPED_OPTIONS = [
	{
		group: 'Frequently used',
		items: COUNTRIES.filter((country) => country.group === 'Frequently used').map(
			(country) => ({
				value: country.country_code,
				label: country.name,
			})
		),
	},
	...COUNTRIES.filter((country) => country.group !== 'Frequently used').map((country) => ({
		value: country.country_code,
		label: country.name,
	})),
];

// Name-keyed grouped variant (mirror of COUNTRIES_NAME_CODE_GROUPED_OPTIONS) for
// plain `<Select>` consumers whose form value is the country name.
export const COUNTRIES_GROUPED_OPTIONS = [
	{
		group: 'Frequently used',
		items: COUNTRIES.filter((country) => country.group === 'Frequently used').map(
			(country) => ({
				value: country.name,
				label: country.name,
			})
		),
	},
	...COUNTRIES.filter((country) => country.group !== 'Frequently used').map((country) => ({
		value: country.name,
		label: country.name,
	})),
];

export const DEFAULT_PHONE_FORMAT = '### ### ### ###';

export const getCountryNameByCode = (code?: string | null): string | null => {
	return COUNTRIES.find((country) => country.country_code === code)?.name ?? null;
};

export const getCountryCodeByName = (name?: string | null): string | null => {
	return COUNTRIES.find((country) => country.name === name)?.country_code ?? null;
};

const nationalityUsageCount = COUNTRIES.reduce<Record<string, number>>((acc, country) => {
	acc[country.nationality] = (acc[country.nationality] ?? 0) + 1;
	return acc;
}, {});

// Same nationality can be shared by several countries (e.g. FR/RE/YT → French); those
// option labels get the country name appended so they stay distinguishable.
const toNationalityOption = (country: CountryData) => ({
	value: country.country_code,
	label:
		(nationalityUsageCount[country.nationality] ?? 0) > 1
			? `${country.nationality} (${country.name})`
			: country.nationality,
});

export const COUNTRIES_NATIONALITY_CODE_OPTION = [
	{
		group: 'Frequently used',
		items: COUNTRIES.filter((country) => country.group === 'Frequently used').map(
			toNationalityOption
		),
	},
	...COUNTRIES.filter((country) => country.group !== 'Frequently used').map(toNationalityOption),
];

export const getNationalityByCode = (code?: string | null): string | null => {
	return COUNTRIES.find((country) => country.country_code === code)?.nationality ?? null;
};

export const getNationalityNamesByCodes = (codes?: string[] | null): string[] =>
	(codes ?? []).map((code) => getNationalityByCode(code) ?? code);
